import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LoaderOverlay from "../components/LoaderOverlay";

function BhashiniLoader() {
  const routerLocation = useLocation();
  const [loading, setLoading] = useState(false);
  const excludedRoutes = new Set([
    "/login_otp",
    "/login_email",
    "/registration",
    "/register_as_support_staff",
    "/register_as_athlete",
    "/register_as_other",
    "/forget-password",
    "/otp-verification",
    "/individual",
    "/create-new-password",
    "/final-submit_individual_registration",
    "/auth_registration",
    "/register_as",
    "/final-status",
    "/otp-verfication",
    "/login/mobile",
  ]);
  const isAllowedRoute = !excludedRoutes.has(routerLocation.pathname);
  useEffect(() => {
    const container = document.getElementById("bhashini-plugin-root");
    // Skip if the route is in the excluded Set or container not found
    if (!isAllowedRoute || !container) {
      return;
    }
    if (document.querySelector('script[src*="bhashini.co.in"]')) {
      console.log("Bhashini script already loaded");
      return;
    }
    const script = document.createElement("script");
    script.src =
      "https://translation-plugin.bhashini.co.in/v3/website_translation_utility.js";
    script.async = true;
    document.body.appendChild(script);
    // --- Detect when user clicks to change language ---
    const handleClick = (e) => {
      // Try to detect language menu or button clicks
      if (e.target.closest(".bhashini-language-item, button, li, a")) {
        setLoading(true);

        // Add small delay before reloading
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    };
    container.addEventListener("click", handleClick);
    return () => {
      // Clean up when navigating away
      container.removeEventListener("click", handleClick);
      if (container.contains(script)) {
        container.removeChild(script);
      }
    };
  }, [routerLocation.pathname, isAllowedRoute]);
  // Show loader briefly when the page reloads (translation applying)
  // useEffect(() => {
  //   if (!isAllowedRoute) return;
  //   setLoading(true);
  //   const timer = setTimeout(() => setLoading(false), 1000);
  //   return () => clearTimeout(timer);
  // }, [routerLocation.pathname, isAllowedRoute]);
  return null;
}

export default BhashiniLoader;
